// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"4d93f099","321":"3239b2be"}[chunkId] + ".chunk.js";
};